angular
  .module("admin")
  .controller(
    "CreateUserCtrl",
    function ($uibModalInstance, SupervisorsResource) {
      this.model = {
        roles: "",
        password: "",
        confirm: "",
      };

      this.roles = [
        {
          id: "atendimento",
          name: "Comercial",
        },
        {
          id: "financeiro",
          name: "Financeiro",
        },
        {
          id: "publicidade",
          name: "Marketing",
        },
        {
          id: "users",
          name: "Gerenciamento de Usuários",
        },
      ];

      this.bindRolesToModel = function () {
        this.model.roles = this.roles
          .filter((r) => r.selected)
          .map((r) => r.id);
      };

      this.dismiss = function () {
        $uibModalInstance.dismiss();
      };

      this.save = function (frm) {
        frm.$setSubmitted(true);

        if (frm.$invalid) return;

        this.bindRolesToModel();

        const dataToSave = {
          name: this.model.name,
          email: this.model.email,
          password: this.model.password,
          roles: this.model.roles,
        };

        SupervisorsResource.create(
          dataToSave,
          () => {
            $uibModalInstance.close();
            this.alerts = [];
          },
          (err) => {
            this.alerts = [
              {
                message:
                  (err.data && err.data.message) || "Erro ao criar usuário",
                type: "danger",
              },
            ];
          }
        );
      };
    }
  );
